<div class="value-history-selector">
    <div class="filter-toggle-all" [class.selected]="allSelected()" [class.partial]="someSelected() && !allSelected()" (click)="onFilterToggleAll($event)">
        Alle
    </div>
    <div class="filter-selector" [class.selected]="marketSalesSelected()" (click)="onFilterMarketSale($event)">Markedssalg</div>
    @if(hasAppraisalRoles()) {
    <div class="filter-selector" [class.selected]="appraisalsSelected()" (click)="onFilterAppraisal($event)">
        etakst @if(hasNorskTakstValueValidationRole()) {
        <span class="appraisal-selector">/Takst</span>
        }
    </div>
    }
    <div class="filter-selector" [class.selected]="publicRegistrationSelected()" (click)="onFilterRegistered($event)">Kun tinglyst</div>
    @if (isCommercial() && hasCommercialAppraisalRoles()) {
    <div class="filter-selector" ev-auth [class.selected]="commercialAppraisalSelected()" (click)="onFilterCommercialAppraisal($event)">evNæringstakst</div>
    } @if (!isCommercial() && hasEvEstimateRoles()) {
    <div ev-auth class="filter-selector" [class.selected]="evEstimateSelected()" (click)="onFilterStoredEvEstimat($event)">Lagrede evEstimat</div>
    }
</div>
